import request from '@axios'

export function getTable(data) {
  return request({
    url: '/table',
    method: 'post',
    data: data
  })
}
export function getData(data) {
  return request({
    url: '/table/data',
    method: 'post',
    data: data
  })
}

export function searchOptions(data) {
  return request({
    url: '/table/search-options',
    method: 'post',
    data: data
  })
}

export function editColumn(data) {
  return request({
    url: '/table/edit-column',
    method: 'post',
    data: data
  })
}

export function editMoneyTargeted(data) {
  return request({
    url: '/table/edit-money-targeted',
    method: 'post',
    data: data
  })
}
export function keywordsAddToGroup(data) {
  return request({
    url: '/table/keywords-add-to-group',
    method: 'post',
    data: data
  })
}

export function exportData(data) {
  return request({
    url: '/table/export-data',
    method: 'post',
    data: data
  })
}
